<template>
  <router-link
    activeClass="plan-card--selected"
    class="plan-card"
    :to="planPathRoute"
  >
    <div class="plan-card__body">
      <div class="plan-card__header">
        <p class="typo-ignore typo-small-title plan-card__title">
          {{ plan.name }}
        </p>
        <p :class="`typo-ignore typo-small-title plan-card__title plan-card__indicator plan-card__indicator--${plan.status}`">
          {{ plan.points_count }}
        </p>
      </div>

      <div class="plan-card__info">
        <p class="typo-ignore typo-tiny plan-card__subtext">
          {{ $t(`frequencies.${plan.frequency}`) }}
        </p>
        <p class="typo-ignore typo-tiny plan-card__subtext">
          {{ statusDetail }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import I18n from 'i18n-js';

import { formatFullDate } from '@/functions/date_format_helpers';

const props = defineProps({
  plan: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const route = useRoute();

const scope = route.params.scope || 'plans';

const statusDetail = computed(() => {
  if (props.plan.status === 'inactive' || props.plan.status === 'archived') {
    return I18n.t(`monitoring_plans.status_label.${props.plan.status}.name`);
  } else {
    return I18n.t('monitoring_plans.due', { date: formatFullDate(props.plan.next_due_date) });
  }
});

const planPathRoute = computed(() => {
  const name = route.params.equipmentId ? 'equipmentPlan' : 'plan';
  return { name, params: { planId: props.plan.id, scope } };
});
</script>
